import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';

import AssistantPageRouteView from './pages/AssistantPageRouteView.vue';
import AgentNavigationPage from './pages/AgentNavigationPage.vue';

import AgentsIndex from './agents/Index.vue';
import OperatorAssistantsIndex from './operatorAssistants/Index.vue';
import KnowledgeBasesIndex from './knowledgeBases/Index.vue';
import KnowledgeBasesShow from './knowledgeBases/Show.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import ResponsesPendingIndex from './responses/Pending.vue';
import AgentScenariosIndex from './scenarios/Index.vue';
import AgentPlaygroundIndex from './playground/Index.vue';
import AgentInboxesIndex from './inboxes/Index.vue';
import CustomToolsIndex from './tools/Index.vue';
import SettingsIndex from './settings/Index.vue';
import UsageIndex from './usage/Index.vue';
import CopilotSettingsIndex from './copilot/Index.vue';

// Р65: раздел ИИ закрыт для администратора организации и оператора — настройку
// агентов ведёт наш человек. Права: 'org_super_admin' (супер-админ организации).
// Платформенный супер-админ получает этот маркер вместе с ролью, поэтому
// заходит везде. Прямой переход по ссылке обычным админом отсекается роутером.
const meta = {
  permissions: ['org_super_admin'],
  featureFlag: FEATURE_FLAGS.AI_ASSISTANT,
  installationTypes: [
    INSTALLATION_TYPES.CLOUD,
    INSTALLATION_TYPES.ENTERPRISE,
    INSTALLATION_TYPES.COMMUNITY,
  ],
};

const adminMeta = {
  ...meta,
};

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/assistant/agents'),
    component: AgentsIndex,
    name: 'assistant_agents_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/operator-assistants'),
    component: OperatorAssistantsIndex,
    name: 'assistant_operator_assistants_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/knowledge-bases'),
    component: KnowledgeBasesIndex,
    name: 'assistant_knowledge_bases_index',
    meta,
  },
  {
    // Р9.3: страница базы знаний — документы или QA внутри конкретной базы.
    path: frontendURL(
      'accounts/:accountId/assistant/knowledge-bases/:knowledgeBaseId'
    ),
    component: KnowledgeBasesShow,
    name: 'assistant_knowledge_bases_show',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/documents'),
    component: DocumentsIndex,
    name: 'assistant_documents_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/responses'),
    component: ResponsesIndex,
    name: 'assistant_responses_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/responses/pending'),
    component: ResponsesPendingIndex,
    name: 'assistant_responses_pending',
    meta,
  },
  {
    // Общий каталог сценариев аккаунта (Р9 п.7) — та же страница без agentId.
    path: frontendURL('accounts/:accountId/assistant/scenarios'),
    component: AgentScenariosIndex,
    name: 'assistant_scenarios_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/assistant/agents/:agentId/scenarios'
    ),
    component: AgentScenariosIndex,
    name: 'assistant_agents_scenarios_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/assistant/agents/:agentId/playground'
    ),
    component: AgentPlaygroundIndex,
    name: 'assistant_agents_playground_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/agents/:agentId/inboxes'),
    component: AgentInboxesIndex,
    name: 'assistant_agents_inboxes_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/tools'),
    component: CustomToolsIndex,
    name: 'assistant_tools_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/settings'),
    component: SettingsIndex,
    name: 'assistant_settings_index',
    meta: adminMeta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/usage'),
    component: UsageIndex,
    name: 'assistant_usage_index',
    meta: adminMeta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant/:navigationPath'),
    component: AgentNavigationPage,
    name: 'assistant_navigation_index',
    meta,
  },
];

export const routes = [
  // Operator copilot («Ассистент») settings — a separate sidebar section
  // from the customer-facing AI agents.
  {
    path: frontendURL('accounts/:accountId/copilot-assistant/settings'),
    component: CopilotSettingsIndex,
    name: 'assistant_copilot_settings_index',
    meta: adminMeta,
  },
  {
    path: frontendURL('accounts/:accountId/assistant'),
    component: AssistantPageRouteView,
    redirect: to => {
      return {
        name: 'assistant_agents_index',
        params: { ...to.params },
      };
    },
    children: [...assistantRoutes],
  },
];
